import {
  CloseOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  SaveOutlined,
} from '@ant-design/icons';
import { Button, Col, Drawer, DrawerProps, Modal, Row, Typography } from 'antd';
import { useSearchParams } from 'react-router-dom';

import PageTitle from '../../components/PageTitle';
import useTypedNavigate from '../../hooks/useTypedNavigate';
import useTypedParams from '../../hooks/useTypedParams';
import styles from './EditRequestJobPostingTemplateDrawer.module.css';

interface EditRequestJobPostingTemplateDrawerProps extends DrawerProps {
  loading?: boolean;
  templateName?: string;
  onSave?: () => void;
  onDelete?: () => void;
  deleteDisabled?: boolean;
}

const EditRequestJobPostingTemplateDrawer = ({
  loading,
  children,
  templateName,
  onSave,
  onDelete,
  deleteDisabled,
  ...props
}: EditRequestJobPostingTemplateDrawerProps) => {
  const { tenant } = useTypedParams({ tenant: String });
  const navigate = useTypedNavigate();
  const [searchParams] = useSearchParams();

  const onClose = () =>
    navigate({
      pathname: '/:tenant/settings/requestJobPostingTemplates/',
      params: { tenant },
      search: searchParams,
    });
  return (
    <>
      <Drawer
        open
        size="large"
        className={styles.drawer}
        closable={false}
        destroyOnClose
        maskClosable
        onClose={onClose}
        title={
          <PageTitle
            title={templateName || '...'}
            level={2}
            extra={[
              <Button key="close" type="text" onClick={onClose} shape="circle">
                <CloseOutlined />
              </Button>,
            ]}
          />
        }
        footer={
          <Row gutter={[16, 16]}>
            <Col>
              <Button
                type="primary"
                icon={<SaveOutlined />}
                loading={loading}
                onClick={() => onSave?.()}
              >
                Salvar
              </Button>
            </Col>
            <Col>
              <Button loading={loading} onClick={onClose}>
                Fechar
              </Button>
            </Col>
            <Col flex={1} />
            <Col>
              <Button
                danger
                icon={<DeleteOutlined />}
                loading={loading}
                disabled={deleteDisabled}
                onClick={() => {
                  return new Promise((resolve) => {
                    const modal = Modal.confirm({});
                    modal.update({
                      title: 'Atenção!',
                      icon: <ExclamationCircleOutlined />,
                      content: (
                        <Typography.Text>
                          Ao confirmar, o modelo de requisição de vaga{' '}
                          <strong>{templateName}</strong> será excluído e não poderá ser recuperado.
                          Você tem certeza que deseja excluir?
                        </Typography.Text>
                      ),
                      cancelButtonProps: {
                        onClick: () => {
                          modal.destroy();
                          resolve(true);
                        },
                      },
                      okText: 'Sim, excluir modelo',
                      okButtonProps: {
                        onClick: () => {
                          onDelete?.();
                          modal.destroy();
                          resolve(false);
                        },
                      },
                      closable: true,
                      maskClosable: true,
                    });
                  });
                }}
              >
                Deletar
              </Button>
            </Col>
          </Row>
        }
        {...props}
      >
        {children}
      </Drawer>
    </>
  );
};

export default EditRequestJobPostingTemplateDrawer;
